var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMultipleArea = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "30px",
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ExternalVizIcon-Copy-4",
    fill: "#FFFFFF",
    stroke: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 29,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "np_line-graph-and-area-chart_365490_37809F",
    transform: "translate(9.000000, 10.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "np_line-graph-and-area-chart_365490_37809F-Copy",
    transform: "translate(10.000000, 5.000000)",
    fill: "#37809F",
    fillOpacity: 0.4,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "21 5.96350672 21 0.474609375 11.9545977 5.26981964 6.86334432 3.18743896 1 7.84848485 0 13.0422363 21 12.9393939"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#37809F",
    fillRule: "nonzero",
    points: "31 21.9883423 31 8 21.0389624 16.8678529 19.2855009 12.3097041 10 16.6310659 10 21.9883423 22.645093 21.9883423"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMultipleArea);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/multiple_area.0afcac8ffdc45d04ec28995a38856a17.svg";